import { WGCWX_SHOP_INNER_PAGE_STATE } from 'state/actions/wgcwx_shop'

const initialState = {
    innerPageOpened: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case WGCWX_SHOP_INNER_PAGE_STATE:
        return {
            ...state,
            innerPageOpened: action.payload.innerPageOpened,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/shop.js